import { render } from "./Footer.vue?vue&type=template&id=2193d98e&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=2193d98e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2193d98e"

export default script